module.exports = __webpack_public_path__ + "media/images/slider-img-01-9e30127ebfd44c37c5c43604e493cfef.jpg";